<script>
  /**@type {string | ??}*/
  export let productImage;
  /**@type {string | ??}*/
  export let borderRadius = 0;
  /**@type {string}*/
  export let alt = "";
  /**@type {boolean}*/
  export let isProduct = false;

</script>

<div class="container-pictures" class:productImage={isProduct}>
  <picture>
    <source
      type="image/webp"
      srcset={`${productImage}`}
      media="(max-width: 520px)"
    />
    <img
      loading="lazy"
      decoding="async"
      src={`${productImage}`}
      style={`border-radius: ${borderRadius}px`}
      {alt}
    />
  </picture>
</div>

<style>
  .container-pictures {
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  picture img {
    width: 100%;
    height: 100%;
    object-fit: contain !important;
  }
</style>
